import React from 'react';
import { Badge } from '@mantine/core';

import {
    getPriceChangeScope,
    getPriceChangeScopeLabel,
    PRICE_CHANGE_SCOPE,
    PriceChangeScopeValue,
} from '../../helpers/priceChangeScope';

const SCOPE_COLORS: Record<PriceChangeScopeValue, string> = {
    [PRICE_CHANGE_SCOPE.STORE]: 'blue',
    [PRICE_CHANGE_SCOPE.SPECIFIC_STORES]: 'teal',
    [PRICE_CHANGE_SCOPE.ZONE]: 'orange',
};

type Props = {
    request?: object | null;
    scope?: PriceChangeScopeValue | string | null;
    size?: 'xs' | 'sm' | 'md';
    descriptive?: boolean;
};

export function PriceChangeScopeBadge({
    request,
    scope,
    size = 'xs',
    descriptive = false,
}: Props) {
    const resolvedScope = getPriceChangeScope(
        scope != null ? { priceChangeScope: scope } : request,
    );
    const label = getPriceChangeScopeLabel(resolvedScope, descriptive);

    if (!resolvedScope || !label) {
        return null;
    }

    return (
        <Badge color={SCOPE_COLORS[resolvedScope]} size={size} variant="light">
            {label}
        </Badge>
    );
}
